import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { EmptySearchIcon } from "../../assets/icons/MUI/NetworkIcons";
import { colors } from "../../theme/palette";

const NoFilteringResultsFigure = () => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        rowGap: "32px",
        gridColumn: "1 / span 3",
        margin: "0 auto",
      }}
    >
      <EmptySearchIcon style={{ width: "240px", height: "180px" }} />
      <Typography
        sx={{
          color: colors.Dark600,
          textAlign: "center",
          fontSize: "14px",
          fontWeight: "400",
          lineHeight: "22px",
        }}
      >
        {t("components.networkController.oopsNoTalents")}
        <br />
        {t("components.networkController.pleaseRefine")}
      </Typography>
    </Box>
  );
};

export default NoFilteringResultsFigure;
